import axios from "./../../config/axios"

function create(data) {
    return axios().post("/purchase/supplier-groups", data, {
        headers: {
            "X-Request-ID": data.idempotentKey
        }
    });
}

function update(data) {
    return axios().put(`/purchase/supplier-groups/${data.id}`, data);
}

function findByID(id) {
    return axios().get(`/purchase/supplier-groups/${id}`)
}
function deleteByID(id) {
    return axios().delete(`/purchase/supplier-groups/${id}`);
}
function search(search) {
    return axios().get('/purchase/supplier-groups-search', { params: { search } })
}

function index(params) {

    params.limit = params.itemsPerPage;
    params.offset = (params.page - 1) * params.itemsPerPage;

    return axios().get("/purchase/supplier-groups", { params })
}

export default {
    create,
    update,
    search,
    findByID,
    deleteByID,
    index
}